module.exports = __webpack_public_path__ + "img/fullscreen.85e6dd57.svg";